import { useTranslations } from 'next-intl'

import { cn } from '@/lib/utils'
import { pushModal } from '@/components/modals'
import { useCurrentUser } from '@/hooks/use-current-user'

export const GetFreeCreditButton = () => {
  return (
    <GetFreeCredit className="w-full text-sm text-white bg-neon-pink hover:bg-neon-pink/80 transition-colors rounded-sm" />
  )
}

export const GetFreeCreditButton2 = () => {
  return (
    <GetFreeCredit className="w-full text-sm text-brand_2 hover:text-brand_2/80 transition-colors" />
  )
}

export const GetFreeCreditLink = () => {
  return (
    <GetFreeCredit className="text-gray-400 hover:text-cyber-magenta transition-colors flex items-center gap-2" />
  )
}

const GetFreeCredit = ({ className }: { className?: string }) => {
  const t = useTranslations('profile-menu')
  const { data: user } = useCurrentUser()

  function handleClick() {
    if (user) {
      pushModal('ReferralModal')
    } else {
      pushModal('LoginModal', { redirectUrl: '/' })
    }
  }

  return (
    <button
      type="button"
      className={cn('flex justify-center items-center gap-2', className)}
      onClick={handleClick}
    >
      <span className="text-lg">💰</span>
      <span className="">{t('get_free_credit')}</span>
    </button>
  )
}
